import { render, staticRenderFns } from "./PoliticaPrivacidade.vue?vue&type=template&id=6b600858&scoped=true"
import script from "./PoliticaPrivacidade.vue?vue&type=script&lang=js"
export * from "./PoliticaPrivacidade.vue?vue&type=script&lang=js"
import style0 from "./PoliticaPrivacidade.vue?vue&type=style&index=0&id=6b600858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b600858",
  null
  
)

export default component.exports